import React from 'react';
import { useSelector } from 'react-redux';
import { IconButton } from '../../../CommonComponents/OPL/IconButton/IconButton';
import { useActivityCsvMutation } from '../../api/useActivityCsvMutation';
import { useTransactionFilters } from '../../hooks/useTransactionFilters';
import { useRouteParams } from '../../hooks/useRouteParams';
import { downloadFile } from '../../../CommonUtils/downloadFile';
import { Tooltip } from '../../../CommonComponents/OPL/Tooltip/Tooltip';
import { toast } from '../../../CommonComponents/OPL/Toast/Toast';
import { MESSAGES } from '../../../CommonConstants';
import { selectCanExportPersonalFinancesToCsv } from '../../../CommonSelectors/CommonAreaSelector';
import { useFeatureFlag } from '../../../_hooks/useFeatureFlag';
import { Feature } from '../../../CommonSelectors/CommonArea.types';

interface Props {
  tab: 'activity' | 'rgl';
}

export const ActivityCsvExport = (props: Props) => {
  const canExportPersonalFinancesToCsv = useSelector(selectCanExportPersonalFinancesToCsv);

  if (!canExportPersonalFinancesToCsv) {
    return null;
  }

  return <Content {...props} />;
};

const Content = ({ tab }: Props) => {
  const transactionFilters = useTransactionFilters();

  const { accountId, clientId, groupId } = useRouteParams();

  const showActivityDetails = useFeatureFlag(Feature.ActivityDetails);

  const { mutateAsync: downloadCsv, isLoading: isDownloadingCsv } = useActivityCsvMutation();

  const onDownloadCsv = async () => {
    try {
      const { fileName, fileBlob } = await downloadCsv({
        tab,
        clientId,
        accountId,
        groupId,
        period: transactionFilters.period.value,
        startDate: transactionFilters.period.dates[0],
        endDate: transactionFilters.period.dates[1],
        showActivityDetails,
      });

      downloadFile(fileName || 'export.csv', fileBlob);
    } catch (error) {
      console.error(error);
      toast.error(MESSAGES.GENERIC_ERROR);
    }
  };

  return (
    <Tooltip content="Export to Excel" placement="bottom-start" delay={500}>
      <IconButton
        icon="far fa-file-export"
        variant="secondary"
        aria-label="Export to Excel"
        isLoading={isDownloadingCsv}
        onClick={onDownloadCsv}
      />
    </Tooltip>
  );
};
